import { render, staticRenderFns } from "./orderLogistics .vue?vue&type=template&id=d6090ba0&scoped=true&"
import script from "./orderLogistics .vue?vue&type=script&lang=js&"
export * from "./orderLogistics .vue?vue&type=script&lang=js&"
import style0 from "./orderLogistics .vue?vue&type=style&index=0&id=d6090ba0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6090ba0",
  null
  
)

export default component.exports